/**
 * Helper de presentation : formate un nombre en notation compacte
 *   1500     -> "1.5k"
 *   1500000  -> "1.5M"
 *   42       -> "42"
 * Garde les arrondis simples pour rester lisible dans les UI denses
 * (cards ressources, dashboards). Pour un formatage localise plus
 * sophistique, utiliser Intl.NumberFormat directement.
 */
export function formatNumber(n: number): string {
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
  if (Math.abs(n) >= 1_000) return (n / 1_000).toFixed(1) + 'k';
  return String(n);
}

/** Format compact qui élide le « .0 » des entiers : 50000 → 50k, 2_500_000 → 2.5M. */
export function compactNumber(n: number): string {
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(n % 1_000 === 0 ? 0 : 1)}k`;
  return `${n}`;
}

/**
 * Durée courte lisible (sans jours) : 45 → « 45s », 90 → « 1m 30s »,
 * 3700 → « 1h 1m ». SOURCE UNIQUE — était réimplémentée dans ~10 composants.
 * Pour le format long (avec jours) d'un compte à rebours, voir
 * stores/nowTick.store.ts -> formatRemaining.
 */
export function humanDuration(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  if (m < 60) return `${m}m${seconds % 60 ? ` ${seconds % 60}s` : ''}`;
  const h = Math.floor(m / 60);
  return `${h}h${m % 60 ? ` ${m % 60}m` : ''}`;
}
